import TextEditorMinimal from '@/components/commons/minimal-tiptap/minimal-editor';
import { HeadingNotFoundElementDataType } from '@/components/sections/builder/elements/body/not-found/type';
import { ElementProps } from '@/components/sections/builder/types';
import { cn } from '@/lib/utils';
import { useBuilderStore } from '@/stores/builder';
import { TypeIcon } from 'lucide-react';
import { shallow } from 'zustand/shallow';

const defaultData: HeadingNotFoundElementDataType = {
  name: 'Heading',
  text: 'Page Not Found',
  size: 'medium',
};

export const ElementContent = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as HeadingNotFoundElementDataType;

  const modifiedLabel = data.text.replace(
    /<strong>(.*?)<\/strong>/g,
    '<span class="font-semibold">$1</span>'
  );

  return (
    <h1
      className={cn(
        'w-full text-[--text-color] duration-100',
        data.size === 'small' && 'text-2xl @sm:text-2xl md:text-2xl lg:text-3xl',
        data.size === 'medium' && 'text-2xl @sm:text-4xl md:text-4xl lg:text-4xl',
        data.size === 'large' && 'text-3xl @sm:text-3xl md:text-5xl lg:text-5xl'
      )}
      data-animation='true'
      dangerouslySetInnerHTML={{ __html: modifiedLabel }}
    />
  );
};

export const ElementSetting = ({ element }: ElementProps) => {
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const data = element.data as HeadingNotFoundElementDataType;

  return (
    <div>
      <h1 className='mb-4 text-sm font-bold'>Heading Settings</h1>
      <div className='my-4'>
        <label className='mb-2 block'>Text</label>
        <TextEditorMinimal
          value={data.text}
          onChange={(val) =>
            builder.setChildData(element.parentId as string, element.id, { text: val })
          }
          output='html'
          className='mb-2 w-full '
          editorProps={{
            attributes: {
              class: 'prose lg:prose-lg prose-blue dark:prose-invert p-2',
            },
          }}
          editable
        />
      </div>
      <div className='my-4 grid grid-cols-2 items-center justify-between gap-2'>
        <label className='block'>Size</label>
        <select
          value={data.size || defaultData.size}
          onChange={(e) =>
            builder.setChildData(element.parentId as string, element.id, { size: e.target.value })
          }
          className='w-full rounded border p-2'
        >
          <option value='small'>Small</option>
          <option value='medium'>Medium</option>
          <option value='large'>Large</option>
        </select>
      </div>
    </div>
  );
};

const HeadingNotFound = {
  type: 'not_found_heading',
  group: 'not_found',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: TypeIcon,
  Icon: TypeIcon,
  childs: [],
};

export default HeadingNotFound;
